import { Directive, HostListener, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appSstformat]',
})
export class SstformatDirective {
  constructor(private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let value = event.target.value.toUpperCase();

    // Remove all special characters
    value = value.replace(/[^A-Z0-9]/g, '');

    // First character -> alphabet only
    let firstChar = value.charAt(0).replace(/[^A-Z]/g, '');

    // Next 2 characters -> numeric only
    let nextTwo = value.substring(1, 3).replace(/\D/g, '');

    // Remaining numeric part
    let numericPart = value.substring(3).replace(/\D/g, '');

    // YY
    let year = numericPart.substring(0, 2);

    // MM
    let month = numericPart.substring(2, 4);

    // Validate month
    if (month.length === 2) {
      let monthNum = parseInt(month, 10);

      if (monthNum < 1) {
        month = '01';
      }

      if (monthNum > 12) {
        month = '12';
      }
    }

    // Last 8 digits
    let suffix = numericPart.substring(4, 12);

    // Build formatted value
    let formattedValue = firstChar + nextTwo;

    // Add YYMM
    if (year.length || month.length) {
      formattedValue += '-';
      formattedValue += year + month;
    }

    // Add suffix
    if (suffix.length) {
      formattedValue += '-' + suffix;
    }

    // Limit total length
    formattedValue = formattedValue.substring(0, 18);

    // Update input field
    event.target.value = formattedValue;

    // Update FormControl
    this.control.control?.setValue(formattedValue, { emitEvent: false });
  }
}

@NgModule({
  declarations: [SstformatDirective],
  exports: [SstformatDirective],
})
export class SstformatDirectiveModule {}
